import Catalog from "@/pages/Catalog";

export default function AsusCatalog() {
  return (
    <Catalog
      collectionFilter="Asus"
      overline="Asus Line"
      titleLine1="Κατάλογος"
      titleAccent="Asus."
      subtitle="Μηχανές της σειράς Asus — επιλεγμένες με φροντίδα, έτοιμες για κάθε διαδρομή."
    />
  );
}
